// extracted by mini-css-extract-plugin
export var active = "_dg-7";
export var container = "_dg-0";
export var evenWidth = "_dg-4";
export var large = "_dg-5";
export var outlet = "_dg-8";
export var slide = "_dg-2";
export var small = "_dg-6";
export var tab = "_dg-3";
export var tabs = "_dg-1";